<template>
  <div/>
</template>
<script>
/**
Используется для тестирования доступности
*/
export default {
  name: 'emptyPage',
  data() {
    return {}
  },
}
</script>